import { CommonModule } from '@angular/common';
import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  HostBinding,
  Output,
} from '@angular/core';
import {
  QaiButtonComponent,
  QaiIconComponent,
} from '@qai/ui';
import { CallVisualAidComponentV2 } from '../../call-visual-aid-v2/call-visual-aid-v2.component';
import { ControlService } from '../../library/control.service';
import { PlayerService } from '../../library/player.service';
import { ErrorDisplayBannerComponent } from '../../error-display-banner/error-display-banner.component';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';
import { AmplitudeTrackingEvents } from 'src/app/utils/enums/amplitude/amplitudeTrackingEvents.enum';
import { CallStoreService } from '../../library/call-store/call-store.service';
import { NativeCallService } from 'src/app/services/native-call.service';

@Component({
  imports: [
    CommonModule,
    QaiButtonComponent,
    QaiIconComponent,
    ErrorDisplayBannerComponent,
  ],
  selector: 'app-call-main-visual-aid',
  standalone: true,
  styleUrls: ['./call-main-visual-aid.css'],
  templateUrl: './call-main-visual-aid.html',
})
export class CallMainVisualAidComponent implements AfterContentInit {
  @ContentChild(CallVisualAidComponentV2)
  childComponent!: CallVisualAidComponentV2;
  @Input() controlService: ControlService | undefined;
  @Input() playerService: PlayerService | undefined;
  @Output() dispplayVisualAidClicked = new EventEmitter<boolean>();
  @Output() currentPageChanged = new EventEmitter<number>();
  @Input() enableVisualAid: boolean = false;

  protected displayVisualAid = false;
  displayErrorBanner = false;

  constructor(
    private amplitudeService: AmplitudeService,
    private cdr: ChangeDetectorRef,
    public callStore: CallStoreService,
    private nativeCallService: NativeCallService
  ) {}

  @Input() isLoading = false;

  @HostBinding('class')
  protected get cssClass() {
    return {
      isLoading: !!this.isLoading,
      'native-ios': this.nativeCallService.isNativeIos,
    };
  }

  handleVisualAidClick() {
    this.playerService?.handleSendUserResponseVisualAid(
      'page-' +
        (this.displayVisualAid ? this.childComponent.currentPage + 1 : 0) +
        ' | '
    );
    this.addVisualAidAmplitudeTrackingEvent();

    if (this.childComponent && !this.displayVisualAid) {
      // Only check for errors when trying to show the visual aid
      const canDisplay = this.childComponent.canDisplayVisualAid();

      if (!canDisplay) {
        this.displayErrorBanner = true;
        this.cdr.detectChanges();
        this.dispplayVisualAidClicked.emit(false);
        return;
      }
    }

    // Normal toggle behavior
    this.displayVisualAid = !this.displayVisualAid;
    this.dispplayVisualAidClicked.emit(this.displayVisualAid);
    this.displayErrorBanner = false;
  }

  ngAfterContentInit() {
    if (this.childComponent) {
      this.childComponent.visualAidClicked.subscribe(() => {
        this.handleVisualAidClick();
      });

      this.childComponent.currentPageChanged.subscribe((page: number) => {
        this.currentPageChanged.emit(page);
      });
    }
  }

  addVisualAidAmplitudeTrackingEvent(): void {
    this.displayVisualAid
      ? this.amplitudeService.trackEvent(
          AmplitudeTrackingEvents.CALL_CLICK_DISPLAY_VISUAL_AID,
          {
            call_type: this.controlService?.callType,
          }
        )
      : this.amplitudeService.trackEvent(
          AmplitudeTrackingEvents.CALL_CLICK_CLOSE_VISUAL_AID,
          {
            call_type: this.controlService?.callType,
          }
        );
  }
}
